import { setCSSStyleDeclaration } from '../../../../../utils/helper';
import { PARA } from '../../../utils/editorStyles.constants';
export const getParagraphNode = options => ({
  content: 'inline*',
  group: 'block',
  parseDOM: [{
    tag: 'p'
  }],
  toDOM: function toDOM() {
    const dom = document.createElement('p');
    const {
      hasInlineStyles
    } = options;
    if (hasInlineStyles) {
      setCSSStyleDeclaration(PARA, dom);
    }
    return {
      dom,
      contentDOM: dom
    };
  }
});